import { useCheckClient } from './useCheckClient'

export const useCheckOnMobileWallet = () => {
  const { isClient } = useCheckClient()

  if (!isClient) return false

  return window && window.isWalletApp
}
